/** The page's view of the backend's `IEquipmentAsset` (backend/src/core/equipment/types.ts). */
export type AssetStatus = 'active' | 'idle';
export type StatusFilter = AssetStatus | 'needsMaintenance' | null;

/** Maps an asset status to its design-token dot colour (for <StatusDot>). */
export const EQUIPMENT_STATUS_COLOR: Record<AssetStatus, string> = {
  active: 'hsl(var(--success))',
  idle: 'hsl(var(--warning))',
};

/**
 * One asset. `areaId` is Trusstor's area key (the floor SVG's `area<id>` /
 * `workers<id>` markers) that tints the map; the location fields are `null`
 * while the asset is Idle.
 */
export interface IEquipmentAsset {
  equipmentId: string;
  name: string;
  type: string;
  typeNick: string;
  company: string | null;
  serialNumber: string | null;
  status: AssetStatus;
  needsMaintenance: boolean;
  floorId: string | null;
  floorNick: string | null;
  areaId: string | null;
  areaNick: string | null;
}
